// components/DeleteConfirmationModal.jsx
import { DEFAULT_IMAGES } from '../constants';

export const DeleteConfirmationModal = ({ widgetDetails, onConfirm, onCancel }) => {
  return (
    <div className='delete-confirmation-popup'>
      <div
        className='confirmation-box'
        style={{
          background: widgetDetails?.background_color?.includes('http') ? `url(${widgetDetails?.background_color})` : widgetDetails?.background_color,
          backgroundSize: 'cover',
        }}
      >
        <div
          className='logo-wrapper'
          style={{
            maxWidth: `${widgetDetails?.header_logo_size}px`,
            width: '100%',
            maxHeight: 'none',
            display: 'inline-block',
          }}
        >
          <img
            src={widgetDetails?.chatbot_logo || DEFAULT_IMAGES.COMNIQ_LOGO}
            alt='chatbot-icon'
            className='chatbot-logo w-100'
            style={{ objectFit: 'contain', display: 'block' }}
          />
        </div>

        <p className='delete-confirmation-text' style={{ color: widgetDetails?.text_color }}>
          Are you sure you want to permanently delete and reset the chat?
        </p>

        <div className='button-group'>
          <button
            className='btn-confirm'
            style={{
              background: widgetDetails?.client_bubble_color,
              color: widgetDetails?.bubble_text_color,
            }}
            onClick={onConfirm}
          >
            Yes!
          </button>

          <button
            className='btn-cancel'
            style={{
              backgroundColor: widgetDetails?.color,
              color: widgetDetails?.agent_bubble_text_color,
              border: `1.5px solid ${widgetDetails?.client_bubble_color}`,
            }}
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
